import React, { Component } from 'react';
import DistrictSchoolCard from "./districtSchoolCardNew";
import DistrictFinancial from "./districtFinancial";
import PropTypes from "prop-types";
import OrderInformationCard from "./orderInformationCard";
import { mealSchools } from './testSchoolData'
//import{eligibleSummaryData} from './eligibilitySummaryData'
import ReactTable from 'react-table';
import { get } from "../../../server/actionsNew";
import NotificationSystem from 'react-notification-system';
import {
    _addNotification, _addNotificationError, getGradeIndexValue, isRegularLunchOrderType,
    standardDateFormat, convertTwoDecimalPoint, getGradeIndex, isInt, showFile, getSchoolGrades, groupBy,
} from '../../../server/util'
import PrintEligibility from './PrintEligibilitySummary'
import _ from 'lodash';
import moment from 'moment';
import { Link } from 'react-router-dom';
import DirectCertificationAlert from '../../SchoolAdmin/Home/DashboardCharts/DirectCertificationAlert';

class districtDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            districtData: [],
            eligibleSummaryData: []
        }
    };
    componentWillMount = () => {
        this.props.changeShowHideSchoolFitler(false);
    }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
        this.getData();
        this.getEligibilitySummary()
    }
    _addNotification(event) {
        this._notificationSystem.addNotification({
            title: "Failed",
            message: 'Something went wrong, Please try again later',
            level: 'error',
            position: 'tc',
            autoDismiss: '5',
            uid: 5,

        });
    }
    getData = () => {
        const districtID = sessionStorage.getItem('districtId');
        const currentDate = moment().format("YYYY-MM-DD")
        get('/reports/districtDashboard/' + districtID + '?&currentDate=' + currentDate + '&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            console.log(data)
            this.setState({ districtData: data.response })
        }).catch(
            (error) => {
                this._addNotification();
                console.log(' response', error)
            }
        )
    }
    getEligibilitySummary = (isExport = false) => {
        const districtID = sessionStorage.getItem('districtId');
        const currentDate = moment().format("YYYY-MM-DD")
        const url = `/reports/eligibilitySummary?districtId=${districtID}&currentDate=${currentDate}&isExport=${isExport}&access_token=`
        get(url).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            this.setState({ loading: false });
            if (isExport) {
                return response.blob()
            } else {
                return response.json()
            }
        }).then(data => {
            if (isExport) {
                let filename = "Eligibility Summary Reports for ";
                showFile(data, filename);
            } else {
                console.log(data.response)
                this.setState({ eligibleSummaryData: data.response })
            }
        }).catch(error => {
            this.setState({ loading: false });
            console.log("Download Failed", error)
        })
    }
    showEligibilitySummaryCols = (accessor) => {
        const { eligibleSummaryData } = this.state;
        return !eligibleSummaryData.every((item) => {
            return item[accessor] === 0 || item[accessor] === null || item[accessor] === undefined;
        });
    }
    getEligibilitySummaryColumns = () => {
        let cols = [

            {
                Header: "Site",
                filterable: false,
                sortable: false,
                accessor: "schoolName",
                style: { textAlign: 'left', whiteSpace: "pre-line" },
                Cell: row => (
                    <span style={{ textAlign: 'left' }}><Link to={`/district/applicationDetails`} onClick={() => {
                        this.props.setSelectedSchool(row.original.mealSchoolId)
                    }} role="button" aria-haspopup="true" aria-expanded="false"><i
                            aria-hidden="true" /> <div style={styles.linkStyle}>{row.original.schoolName}</div></Link></span>

                ),
                Footer: () => (
                    <span style={{ textAlign: 'left' }}>
                        Totals
                    </span>
                )
            },
            {
                Header: "Total Free",
                accessor: "totalFree",
                show: this.showEligibilitySummaryCols('totalFree'),
                style: { textAlign: 'right', whiteSpace: "pre-line" },
                filterable: false,
                Cell: row => (<p>{(row.original.totalFree)}</p>),
                Footer: () => (
                    <span style={{ textAlign: 'right' }}>
                        {/* Total Amount: $ {this.state.data.totalOrdersPrice ? this.state.data.totalOrdersPrice: '0.00'} */}
                        <p>{_.sumBy(this.state.eligibleSummaryData, (o) => { return (o.totalFree || 0); })}</p>
                    </span>
                )
            },
            {
                Header: "Total Reduced",
                accessor: "totalRed",
                show: this.showEligibilitySummaryCols('totalRed'),
                style: { textAlign: 'right', whiteSpace: "pre-line" },
                filterable: false,
                Cell: row => (<p> {(row.original.totalRed)}</p>),
                Footer: () => (
                    <span style={{ textAlign: 'right' }}>
                        {/* Total Amount: $ {this.state.data.totalOrdersPrice ? this.state.data.totalOrdersPrice: '0.00'} */}
                        <p>{_.sumBy(this.state.eligibleSummaryData, (o) => { return (o.totalRed || 0); })}</p>
                    </span>
                )
            },
            {
                Header: "Total Paid",
                accessor: "totalPaid",
                show: this.showEligibilitySummaryCols('totalPaid'),
                style: { textAlign: 'right', whiteSpace: "pre-line" },
                filterable: false,
                Cell: row => (<p> {(row.original.totalPaid)}</p>),
                Footer: () => (
                    <span style={{ textAlign: 'right' }}>
                        {/* Total Amount: $ {this.state.data.totalOrdersPrice ? this.state.data.totalOrdersPrice: '0.00'} */}
                        <p>{_.sumBy(this.state.eligibleSummaryData, (o) => { return (o.totalPaid || 0); })}</p>
                    </span>
                )
            },
            {
                Header: "Total Inactive",
                accessor: "totalInactive",
                show: this.showEligibilitySummaryCols('totalInactive'),
                style: { textAlign: 'right', whiteSpace: "pre-line" },
                filterable: false,
                Cell: row => (<p> {(row.original.totalInactive)}</p>),
                Footer: () => (
                    <span style={{ textAlign: 'right' }}>
                        {/* Total Amount: $ {this.state.data.totalOrdersPrice ? this.state.data.totalOrdersPrice: '0.00'} */}
                        <p>{_.sumBy(this.state.eligibleSummaryData, (o) => { return (o.totalInactive || 0); })}</p>
                    </span>
                )
            },
            {
                Header: "Income Free",
                accessor: "incomeFree",
                show: this.showEligibilitySummaryCols('incomeFree'),
                style: { textAlign: 'right', whiteSpace: "pre-line" },
                filterable: false,
                Cell: row => (<div><span style={{ textAlign: 'right' }}>{(row.original.incomeFree)}</span>
                </div>),
                Footer: () => (
                    <span style={{ textAlign: 'right' }}>
                        {/* Total Amount: $ {this.state.data.totalOrdersPrice ? this.state.data.totalOrdersPrice: '0.00'} */}
                        {_.sumBy(this.state.eligibleSummaryData, (o) => { return (o.incomeFree || 0); })}
                    </span>
                )
            },
            {
                Header: "Income Red.",
                accessor: "incomeRed",
                show: this.showEligibilitySummaryCols('incomeRed'),
                style: { textAlign: 'right' },
                filterable: false,
                Cell: row => (<span style={{ textAlign: 'right' }}>{(row.original.incomeRed)}</span>),
                Footer: () => (
                    <span style={{ textAlign: 'right' }}>
                        {/* Total Amount: $ {this.state.data.totalOrdersPrice ? this.state.data.totalOrdersPrice: '0.00'} */}
                        {_.sumBy(this.state.eligibleSummaryData, (o) => { return (o.incomeRed || 0); })}
                    </span>
                )
            },
            {
                Header: "Income Paid",
                accessor: "incomePaid",
                show: this.showEligibilitySummaryCols('incomePaid'),
                style: { textAlign: 'right' },
                filterable: false,
                Cell: row => (<span style={{ textAlign: 'right' }}>{(row.original.incomePaid)}</span>),
                Footer: () => (
                    <span style={{ textAlign: 'right' }}>
                        {/* Total Amount: $ {this.state.data.totalOrdersPrice ? this.state.data.totalOrdersPrice: '0.00'} */}
                        {_.sumBy(this.state.eligibleSummaryData, (o) => { return (o.incomePaid || 0); })}
                    </span>
                )
            },
            /*  {
                 Header: "NJEIE",
                 accessor: "njeie",
                 style: { textAlign: 'right', whiteSpace: "pre-line" },
                 filterable: false,
                 Cell: row => (<div><span style={{ textAlign: 'right' }}>{(row.original.njeie)}</span>
                 </div>),
                 Footer: () => (
                     <span style={{ textAlign: 'right' }}>
                         {_.sumBy(this.state.eligibleSummaryData, (o) => { return (o.njeie || 0); })}
                     </span>
                 )
 
             }, */
            {
                Header: "State Free",
                accessor: "stateFree",
                show: this.showEligibilitySummaryCols('stateFree'),
                style: { textAlign: 'right', whiteSpace: "pre-line" },
                filterable: false,
                Cell: row => (<div><span style={{ textAlign: 'right' }}>{(row.original.stateFree)}</span>
                </div>),
                Footer: () => (
                    <span style={{ textAlign: 'right' }}>
                        {_.sumBy(this.state.eligibleSummaryData, (o) => { return (o.stateFree || 0); })}
                    </span>
                )

            },
            {
                Header: "State Reduced",
                accessor: "stateReduced",
                show: this.showEligibilitySummaryCols('stateReduced'),
                style: { textAlign: 'right', whiteSpace: "pre-line" },
                filterable: false,
                Cell: row => (<div><span style={{ textAlign: 'right' }}>{(row.original.stateReduced)}</span>
                </div>),
                Footer: () => (
                    <span style={{ textAlign: 'right' }}>
                        {_.sumBy(this.state.eligibleSummaryData, (o) => { return (o.stateReduced || 0); })}
                    </span>
                )

            },
            {
                Header: "Temp Free",
                accessor: "tempFree",
                show: this.showEligibilitySummaryCols('tempFree'),
                style: { textAlign: 'right' },
                filterable: false,
                Cell: row => (<span style={{ textAlign: 'right' }}>{(row.original.tempFree)}</span>),
                Footer: () => (
                    <span style={{ textAlign: 'right' }}>
                        {/* Total Amount: $ {this.state.data.totalOrdersPrice ? this.state.data.totalOrdersPrice: '0.00'} */}
                        {_.sumBy(this.state.eligibleSummaryData, (o) => { return (o.tempFree || 0); })}
                    </span>
                )
            },
            {
                Header: "Temp Red.",
                accessor: "tempRed",
                show: this.showEligibilitySummaryCols('tempRed'),
                style: { textAlign: 'right', whiteSpace: "pre-line" },
                filterable: false,
                Cell: row => (<div><span style={{ textAlign: 'right' }}>{(row.original.tempRed)}</span>
                </div>),
                Footer: () => (
                    <span style={{ textAlign: 'right' }}>
                        {/* Total Amount: $ {this.state.data.totalOrdersPrice ? this.state.data.totalOrdersPrice: '0.00'} */}
                        {_.sumBy(this.state.eligibleSummaryData, (o) => { return (o.tempRed || 0); })}
                    </span>
                )
            },
            {
                Header: "SNAP",
                accessor: "snap",
                show: this.showEligibilitySummaryCols('snap'),
                style: { textAlign: 'right' },
                filterable: false,
                Cell: row => (<span style={{ textAlign: 'right' }}>{(row.original.snap)}</span>),
                Footer: () => (
                    <span style={{ textAlign: 'right' }}>
                        {/* Total Amount: $ {this.state.data.totalOrdersPrice ? this.state.data.totalOrdersPrice: '0.00'} */}
                        {_.sumBy(this.state.eligibleSummaryData, (o) => { return (o.snap || 0); })}
                    </span>
                )
            },
            {
                Header: "TANF",
                accessor: "tanf",
                show: this.showEligibilitySummaryCols('tanf'),
                style: { textAlign: 'right' },
                filterable: false,
                Cell: row => (<span style={{ textAlign: 'right' }}>{(row.original.tanf)}</span>),
                Footer: () => (
                    <span style={{ textAlign: 'right' }}>
                        {/* Total Amount: $ {this.state.data.totalOrdersPrice ? this.state.data.totalOrdersPrice: '0.00'} */}
                        {_.sumBy(this.state.eligibleSummaryData, (o) => { return (o.tanf || 0); })}
                    </span>
                )
            },
            {
                Header: "Foster Child",
                accessor: "fosterChild",
                show: this.showEligibilitySummaryCols('fosterChild'),
                style: { textAlign: 'right' },
                filterable: false,
                Cell: row => (<span style={{ textAlign: 'right' }}>{(row.original.fosterChild)}</span>),
                Footer: () => (
                    <span style={{ textAlign: 'right' }}>
                        {/* Total Amount: $ {this.state.data.totalOrdersPrice ? this.state.data.totalOrdersPrice: '0.00'} */}
                        {_.sumBy(this.state.eligibleSummaryData, (o) => { return (o.fosterChild || 0); })}
                    </span>
                )
            },
            {
                Header: "Inst",
                accessor: "inst",
                show: this.showEligibilitySummaryCols('inst'),
                style: { textAlign: 'right' },
                filterable: false,
                Cell: row => (<span style={{ textAlign: 'right' }}>{(row.original.inst)}</span>),
                Footer: () => (
                    <span style={{ textAlign: 'right' }}>
                        {/* Total Amount: $ {this.state.data.totalOrdersPrice ? this.state.data.totalOrdersPrice: '0.00'} */}
                        {_.sumBy(this.state.eligibleSummaryData, (o) => { return (o.inst || 0); })}
                    </span>
                )
            },
            {
                Header: "FDPIR",
                accessor: "fdpir",
                show: this.showEligibilitySummaryCols('fdpir'),
                style: { textAlign: 'right' },
                filterable: false,
                Cell: row => (<span style={{ textAlign: 'right' }}>{(row.original.fdpir)}</span>),
                Footer: () => (
                    <span style={{ textAlign: 'right' }}>
                        {/* Total Amount: $ {this.state.data.totalOrdersPrice ? this.state.data.totalOrdersPrice: '0.00'} */}
                        {_.sumBy(this.state.eligibleSummaryData, (o) => { return (o.fdpir || 0); })}
                    </span>
                )
            },
            {
                Header: "Hd/Ev Start",
                accessor: "hdStart",
                show: this.showEligibilitySummaryCols('hdStart'),
                style: { textAlign: 'right', whiteSpace: "pre-line" },
                filterable: false,
                Cell: row => (<div><span style={{ textAlign: 'right' }}>{(row.original.hdStart)}</span>
                </div>),
                Footer: () => (
                    <span style={{ textAlign: 'right' }}>
                        {/* Total Amount: $ {this.state.data.totalOrdersPrice ? this.state.data.totalOrdersPrice: '0.00'} */}
                        {_.sumBy(this.state.eligibleSummaryData, (o) => { return (o.hdStart || 0); })}
                    </span>
                )
            },
            {
                Header: "Homeless",
                accessor: "homeless",
                show: this.showEligibilitySummaryCols('homeless'),
                style: { textAlign: 'right' },
                filterable: false,
                Cell: row => (<span style={{ textAlign: 'right' }}>{(row.original.homeless)}</span>),
                Footer: () => (
                    <span style={{ textAlign: 'right' }}>
                        {/* Total Amount: $ {this.state.data.totalOrdersPrice ? this.state.data.totalOrdersPrice: '0.00'} */}
                        {_.sumBy(this.state.eligibleSummaryData, (o) => { return (o.homeless || 0); })}
                    </span>
                )
            },
            {
                Header: "Migrant",
                accessor: "migrant",
                show: this.showEligibilitySummaryCols('migrant'),
                style: { textAlign: 'right' },
                filterable: false,
                Cell: row => (<span style={{ textAlign: 'right' }}>{(row.original.migrant)}</span>),
                Footer: () => (
                    <span style={{ textAlign: 'right' }}>
                        {/* Total Amount: $ {this.state.data.totalOrdersPrice ? this.state.data.totalOrdersPrice: '0.00'} */}
                        {_.sumBy(this.state.eligibleSummaryData, (o) => { return (o.migrant || 0); })}
                    </span>
                )
            },
            {
                Header: "Runaway",
                accessor: "runway",
                show: this.showEligibilitySummaryCols('runway'),
                style: { textAlign: 'right' },
                filterable: false,
                Cell: row => (<span style={{ textAlign: 'right' }}>{(row.original.runway)}</span>),
                Footer: () => (
                    <span style={{ textAlign: 'right' }}>
                        {/* Total Amount: $ {this.state.data.totalOrdersPrice ? this.state.data.totalOrdersPrice: '0.00'} */}
                        {_.sumBy(this.state.eligibleSummaryData, (o) => { return (o.runway || 0); })}
                    </span>
                )
            },
            {
                Header: "Medicaid Free",
                accessor: "medicaidFree",
                show: this.showEligibilitySummaryCols('medicaidFree'),
                style: { textAlign: 'right', whiteSpace: "pre-line" },
                filterable: false,
                Cell: row => (<div><span style={{ textAlign: 'right' }}>{(row.original.medicaidFree)}</span>
                </div>),
                Footer: () => (
                    <span style={{ textAlign: 'right' }}>
                        {/* Total Amount: $ {this.state.data.totalOrdersPrice ? this.state.data.totalOrdersPrice: '0.00'} */}
                        {_.sumBy(this.state.eligibleSummaryData, (o) => { return (o.medicaidFree || 0); })}
                    </span>
                )
            },
            {
                Header: "Medicaid Reduced",
                accessor: "medicaidRed",
                show: this.showEligibilitySummaryCols('medicaidRed'),
                style: { textAlign: 'right' },
                filterable: false,
                Cell: row => (<span style={{ textAlign: 'right' }}>{(row.original.medicaidRed)}</span>),
                Footer: () => (
                    <span style={{ textAlign: 'right' }}>
                        {/* Total Amount: $ {this.state.data.totalOrdersPrice ? this.state.data.totalOrdersPrice: '0.00'} */}
                        {_.sumBy(this.state.eligibleSummaryData, (o) => { return (o.medicaidRed || 0); })}
                    </span>
                )
            }, {
                Header: "Direct Cert",
                accessor: "directCert",
                show: this.showEligibilitySummaryCols('directCert'),
                style: { textAlign: 'right' },
                filterable: false,
                Cell: row => (<span style={{ textAlign: 'right' }}>{(row.original.directCert)}</span>),
                Footer: () => (
                    <span style={{ textAlign: 'right' }}>
                        {/* Total Amount: $ {this.state.data.totalOrdersPrice ? this.state.data.totalOrdersPrice: '0.00'} */}
                        {_.sumBy(this.state.eligibleSummaryData, (o) => { return (o.directCert || 0); })}
                    </span>
                )
            }, {
                Header: "Custom Case",
                accessor: "customCase",
                show: this.showEligibilitySummaryCols('customCase'),
                style: { textAlign: 'right' },
                filterable: false,
                Cell: row => (<span style={{ textAlign: 'right' }}>{(row.original.customCase)}</span>),
                Footer: () => (
                    <span style={{ textAlign: 'right' }}>
                        {/* Total Amount: $ {this.state.data.totalOrdersPrice ? this.state.data.totalOrdersPrice: '0.00'} */}
                        {_.sumBy(this.state.eligibleSummaryData, (o) => { return (o.customCase || 0); })}
                    </span>
                )
            }
        ];
        return cols;


    }

    render() {
        return (
            <div>
                <NotificationSystem ref="notificationSystem" />
                <section>
                    <div className="container">
                        <div className="sectionTitle">
                            <h2>
                            </h2>
                        </div>
                        <div className='row'>
                            <div className='col-md-12'>
                                <DirectCertificationAlert
                                    districtId={sessionStorage.getItem('districtId')}
                                    schoolId={0}
                                    schoolYear={moment().format('YYYYMM')}
                                    self={this}
                                />
                            </div>
                        </div>
                        <div className="row set-dashboard-center">
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <DistrictSchoolCard school={this.state.districtData} schoolDropdownData={this.props.schoolList} />
                            </div>

                        </div>
                        <div className="row set-dashboard-center">
                            <div className="row sectionTitle priceTitle bg-color-1" style={{ margin: 15 }}>
                                <span className="col-lg-10 col-md-10 col-sm-10 col-xs-10" style={styles.custHeader}>Eligibility Summary
                                </span>
                                <span className="col-lg-2 col-md-2 col-sm-2 col-xs-2" style={styles.pdfStyle}>
                                    <a title="Click to import Direct Certification" style={{ cursor: 'pointer', color: '#fff' }}
                                        onClick={() => {
                                            this.context.router.history.push('/district/importCertificationData');
                                        }}>
                                        <i className='fa fa-id-card fa-2x'></i>
                                    </a>
                                    <PrintEligibility downloadPDF={this.getEligibilitySummary} />
                                </span>
                            </div>
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <ReactTable

                                    showPaginationBottom={false}
                                    columns={
                                        this.getEligibilitySummaryColumns()
                                    }
                                    minRows={this.state.eligibleSummaryData.length}
                                    data={this.state.eligibleSummaryData}
                                    defaultPageSize={10}
                                    className="-striped -highlight" />
                            </div>
                        </div>
                        <br />
                        <div className="row set-dashboard-center">
                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                <OrderInformationCard school={this.state.districtData} />
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                <DistrictFinancial {...this.props} school={this.state.districtData} />
                            </div>
                        </div>
                    </div>
                </section>
            </div>

        );
    }
}

const styles = {
    custHeader: {
        color: "#ffffff",
        textTransform: "capitalize",
        fontSize: 24,
        fontFamily: "'Dosis', sans-serif",
        fontWeight: 700,
        paddingLeft: 0
    },
    pdfStyle: {
        textAlign: "right",
        paddingRight: 0,
        color: "#ffffff"
    }
}
districtDashboard.contextTypes = {
    router: PropTypes.object.isRequired
}

export default districtDashboard;




// WEBPACK FOOTER //
// ./src/components/District/Home/districtDashboardNew.jsx